angular.module('shared').directive('detectWindows', ["$timeout", function($timeout) {
  return {
    restrict: 'A',
    link: function(scope, element) {
      if (window.navigator.appVersion.indexOf("Win") > -1) {
        return element.addClass('fix-windows-fonts');
      }
    }
  };
}]);
